module.exports = ['$resource', function ($resource) {

    let UserFilters = $resource('/userfilters/item',
        {},
        {
            'get': {method: 'get'},
            'save': {method: 'POST'}
        }
    );

    let save = UserFilters.save;

    // Required for "easy" .save in controllers
    UserFilters.save = function (...args) {

        if (args[0].id) {
            this.update.apply(this, args);
        } else {
            save.apply(this, args);
        }
    };

    return UserFilters;
}];